import { render, staticRenderFns } from "./home_landing.vue?vue&type=template&id=2f953329&scoped=true"
import script from "./home_landing.vue?vue&type=script&lang=js"
export * from "./home_landing.vue?vue&type=script&lang=js"
import style0 from "./home_landing.vue?vue&type=style&index=0&id=2f953329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f953329",
  null
  
)

export default component.exports